var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headerContainer"},[_c('HeaderLogo',{scopedSlots:_vm._u([{key:"headerImage",fn:function(){return [_c('img',{attrs:{"src":"agroclimate_logo.png"}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }